import Vue from "vue";

import lowercaseDirective from "./lowercase.directive";
Vue.directive("lowercase", lowercaseDirective);

import uppercaseDirective from "./uppercase.directive";
Vue.directive("uppercase", uppercaseDirective);

import alphanumericDirective from "./alphanumeric.directive";
Vue.directive("alphanumeric", alphanumericDirective);

import spanishDirective from "./spanish.directive";
Vue.directive("spanish", spanishDirective);

import numbersDirective from "./numbers.directive";
Vue.directive("numeric-only", numbersDirective);
